export const LinkedInIcon = (props: React.ComponentPropsWithoutRef<"svg">) => {
	return (
		<svg viewBox="0 0 28 27" {...props}>
			<use href="/images/icons.svg#vlw-linkedin" />
		</svg>
	)
}
